module.exports = __webpack_public_path__ + "static/media/andaman-tourisms-logo.532bac9a.webp";